import { render } from "./TermsOfUserView.vue?vue&type=template&id=105b1986&ts=true"
import script from "./TermsOfUserView.vue?vue&type=script&lang=ts"
export * from "./TermsOfUserView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__